'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'citrus-slice';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e2f5';
var svgPathData = 'M496 208c0 159.1-128.9 288-288 288-69.7 0-133.6-24.7-183.4-66L63.7 391c40.8 35.5 94 57 152.3 57 128.1 0 232-103.9 232-232 0-58.3-21.5-111.6-57-152.3L430 24.6c41.2 49.8 66 113.7 66 183.4zM184 429.6c-41.3-6.1-78.8-24-109-50l99.1-99.1c3.2 1.5 6.5 2.8 9.9 3.8l0 145.3zm16 1.8l0-143.8c2.6 .3 5.3 .4 8 .4 19.2 0 36.8-6.8 50.6-18.1L363 374.3c-38.6 35.8-90.2 57.7-147 57.7-5.4 0-10.7-.2-16-.6zm69.9-172.8c11.3-13.8 18.1-31.4 18.1-50.6 0-2.7-.1-5.4-.4-8l143.8 0c.4 5.3 .6 10.6 .6 16 0 56.8-21.9 108.4-57.7 147L269.9 258.6zM284.3 184c-1.1-3.4-2.4-6.7-3.8-9.9L379.6 75c26.1 30.2 43.9 67.7 50 109l-145.3 0zm-16.1 2.4c2.4 6.8 3.7 14 3.7 21.6 0 35.3-28.7 64-64 64-7.6 0-14.9-1.3-21.6-3.7l81.9-81.9zM1.2 430.8c3.9 3.6 7.9 7.2 12 10.6 52.8 44.1 120.7 70.6 194.8 70.6 167.9 0 304-136.1 304-304 0-74.1-26.5-142-70.6-194.8-3.4-4.1-7-8.1-10.6-12l-11.3 11.3-407 407-11.3 11.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCitrusSlice = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;